import React from 'react'
import { Link } from 'react-router-dom'
import Typography from '@material-ui/core/Typography'
import Box from '@material-ui/core/Box'
import Card from '@material-ui/core/Card'
import CardActionArea from '@material-ui/core/CardActionArea'
import CardActions from '@material-ui/core/CardActions'
import CardContent from '@material-ui/core/CardContent'
import CardMedia from '@material-ui/core/CardMedia'
import Placeholder from '../images/placeholder.png'
import ArrowRightAlt from 'components/material-symbol/icons/ArrowRightAlt'
import { makeStyles } from '@material-ui/core/styles'
import { gtmEvent } from 'lib/gtm'
import {
  interactiveCardFocusStyles,
  interactiveCardHoverStyles,
  interactiveCardInteractionStyles,
  interactiveCardLinkResetStyles,
} from 'lib/styles/interactive-card-hover'

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 12,
    border: '1px solid #E0E0E0',
    boxShadow: 'none',
    overflow: 'hidden',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    ...interactiveCardHoverStyles(theme),
  },
  cardAction: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    alignSelf: 'stretch',
    cursor: 'pointer',
    ...interactiveCardLinkResetStyles,
    ...interactiveCardFocusStyles,
    ...interactiveCardInteractionStyles,
    '&:hover': {
      backgroundColor: 'transparent',
    },
    '&:active': {
      backgroundColor: 'transparent',
    },
  },
  cardContent: {
    padding: theme.spacing(2),
    flex: 1,
    '&:last-child': {
      paddingBottom: theme.spacing(1.5),
    },
  },
  title: {
    margin: 0,
    fontSize: '0.9375rem',
    fontWeight: 600,
    lineHeight: 1.3,
    color: '#172024',
    [theme.breakpoints.up('sm')]: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
  },
  description: {
    marginTop: theme.spacing(0.5),
    fontSize: '0.8125rem',
    lineHeight: 1.4,
    color: theme.palette.text.secondary,
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
  },
  cardActions: {
    padding: theme.spacing(0, 2, 2),
    marginTop: 'auto',
  },
  viewDetails: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.primary.main,
  },
}))

const StagesCard = ({ image, title, subtitle, url }) => {
  const classes = useStyles()

  const handleClick = name => {
    gtmEvent({
      event: 'activities-click',
      activitiesCategory: 'coach-activities',
      activitiesAction: 'plan-click',
      activitiesLabel: name,
    })
  }

  return (
    <Card className={classes.card} elevation={0}>
      <CardActionArea
        className={classes.cardAction}
        component={Link}
        to={url}
        onClick={() => handleClick(title)}
        aria-label={`View details for ${title}`}
      >
        <CardMedia
          component="img"
          height="140"
          image={image || Placeholder}
          alt=""
          draggable={false}
        />
        <CardContent className={classes.cardContent}>
          <Typography component="p" className={classes.title}>
            {title}
          </Typography>
          <Typography component="p" className={classes.description}>
            {subtitle}
          </Typography>
        </CardContent>
        <CardActions className={classes.cardActions}>
          <Box className={classes.viewDetails} component="span">
            View details
            <ArrowRightAlt fontSize="small" />
          </Box>
        </CardActions>
      </CardActionArea>
    </Card>
  )
}

export default StagesCard
